import React from "react";
import "./FunctionHall.css";
import { FaSnowflake, FaLeaf, FaParking, FaMapMarkerAlt, FaGem } from 'react-icons/fa';
import { GiChefToque } from 'react-icons/gi'; // In-house Catering
import {  FaUtensils} from "react-icons/fa";
function FunctionHall() {
  return (
    <div className="function-hall-container">
      {/* 🌟 HOME */}
      <div className="fh-hero-section" id="home">
        <div className="fh-hero-overlay">
          <h1 className="fh-title">Your Moments, Our Venue</h1>
          <p className="fh-subtitle">Next Open Function Hall</p>
          <a href="#booking" className="fh-btn">Book Your Event</a>
        </div>
      </div>

      {/* ✨ FEATURES */}
      <div className="fh-features-section">
        <h1 className="fh-section-title">Why Choose Us?</h1>
       <div className="fh-feature-list">
  <div className="fh-feature-item">
    <FaSnowflake className="icon" /> Central A/C Hall
  </div>
  <div className="fh-feature-item">
    <FaLeaf className="icon" /> Open Lawn
  </div>
  <div className="fh-feature-item">
    <FaUtensils className="icon" /> Dining Area
  </div>
  <div className="fh-feature-item">
    <FaParking className="icon" /> Valet Parking
  </div>
</div>
      </div>

      {/* 💬 TESTIMONIALS */}
      <div className="fh-testimonials-section">
        <h1 className="fh-section-title">What Our Guests Say</h1>
        <div className="fh-carousel">
          <blockquote className="fh-quote">"Fantastic venue and great service!"</blockquote>
          <blockquote className="fh-quote">"Our wedding was magical here."</blockquote>
          <blockquote className="fh-quote">"Spacious, clean, and elegant!"</blockquote>
        </div>
      </div>

      {/* 🖼️ GALLERY */}
      <section className="fh-gallery-section" id="gallery">
        <h2 className="fh-section-title">Gallery</h2>
        <div className="fh-gallery-grid">
          <img src="https://tse2.mm.bing.net/th/id/OIP.cChWpcyfEv9dt5y2vEg1KwHaEy?r=0&rs=1&pid=ImgDetMain&o=7&rm=3" alt="Wedding" />
          <img src="https://i.pinimg.com/originals/c9/61/84/c96184c6801570392e0e04211ab5e958.jpg" alt="Lawn" />
          <img src="https://dej5dgk6v2ulk.cloudfront.net/Web/res/images/privilege/0_NEW/DINING/CNX/The-Vorra-Bistro/Indoor-2.jpg" alt="Dining" />
          <img src="https://images.hdqwalls.com/wallpapers/skycrappers-buildings-lights-night-view-o6.jpg" alt="Night View" />
          <img src="https://asset-2.tstatic.net/style/foto/bank/images/Potret-acara-syukuran-rumah-baru-Irish-Bella-dan-Haldy-Sabri.jpg" alt="" />
          <img src="https://i.ytimg.com/vi/ErwKsekTFxA/maxresdefault.jpg" alt="" />
          <img src="https://i.ytimg.com/vi/sTAUmuuO14M/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGH8gPigmMA8=&rs=AOn4CLCbKGeKMMa_0G6jwDqiPwJR4lIn8A" alt="" />
        </div>
      </section>

      {/* 📝 BOOKING INFO */}
      <section className="fh-booking-section" id="booking">
        <h2 className="fh-section-title">Book Your Event</h2>
        <p className="fh-booking-info">
          We’d love to host your special occasion! Please visit us in person or
          call us to check availability and reserve your date.
        </p>
        <div className="fh-contact-box">
          <p>📍 Location: Hyderabad, India</p>
          <p>📞 Phone: +91-98765-43210</p>
          <p>🕙 Timing: 9:00 AM – 9:00 PM</p>
        </div>

        <aside className="fh-sidebar">
          <h4 className="fh-sidebar-title">Pricing & Terms</h4>
          <ul className="fh-sidebar-list">
            <li>Hall Rent: ₹50,000 / day</li>
            <li>Lawn Use: ₹20,000</li>
            <li>Advance: 50% to confirm</li>
            <li>Refund policy applies</li>
          </ul>
        </aside>
      </section>

      {/* 🏢 ABOUT */}
      <div className="fh-about-section" id="about">
        <h2 className="fh-section-title">About Next Open Function Hall</h2>
        <p className="fh-about-description">
          Established in 2015, Next Open Function Hall is committed to delivering
          unforgettable event experiences. From lavish weddings to corporate galas,
          our venue offers both elegance and convenience.
        </p>

        <h3 className="fh-subsection-title">Our Facilities</h3>
       <div className="fh-facility-cards">
      <div className="fh-facility-card">
        <FaSnowflake className="facility-icon" />
        <p>Central A/C Hall</p>
      </div>
      <div className="fh-facility-card">
        <FaLeaf className="facility-icon" />
        <p>Outdoor Lawn</p>
      </div>
      <div className="fh-facility-card">
        <FaParking className="facility-icon" />
        <p>Parking for 100+ Cars</p>
      </div>
      <div className="fh-facility-card">
        <GiChefToque className="facility-icon" />
        <p>In-house Catering & Decor</p>
      </div>
      <div className="fh-facility-card">
        <FaMapMarkerAlt className="facility-icon" />
        <p>Prime City Location</p>
      </div>
      <div className="fh-facility-card">
        <FaGem className="facility-icon" />
        <p>Affordable Luxury</p>
      </div>
    </div>

    
      </div>

      {/* 📞 FOOTER */}
      <footer className="fh-footer">
        <p className="fh-footer-contact">Next Open Function Hall | 📍 Hyderabad, India | 📞 +91-98765-43210</p>
        <div className="fh-footer-links">
          <a href="#home">Home</a>
          <a href="#gallery">Gallery</a>
          <a href="#booking">Booking</a>
          <a href="#about">About</a>
        </div>
      </footer>
    </div>
  );
}

export default FunctionHall;
